/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductTypeModel>>;
export function request(
  body: defs.basics.ProductTypeRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productType/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
